import "./ShopPageCatalogue.css";

import React from "react";

import { useOutletContext } from "react-router-dom";

import { useState, useEffect, useRef } from "react";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Pagination from "@mui/material/Pagination";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";

import { ShopPageCard } from "./ShopPageCard";

export const ShopPageCatalogue = () => {
  let utilityProps = useOutletContext();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);

  const [searchFiledValue, setSearchFiledValue] = useState("");

  const indexOfLastItem = utilityProps[12] * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const [currentItems, setCurrentItems] = useState(
    utilityProps[0].slice(
      utilityProps[12] * itemsPerPage - itemsPerPage,
      utilityProps[12] * itemsPerPage
    )
  );

  const shopCatalogueContainer = useRef(null);

  useEffect(() => {
    let href = window.location.href;
    let subHref = href.split("/")[3];
    if (subHref === "shop") {
      utilityProps[6](false);
    }
  }, []);

  const handlePageChange = (event, value) => {
    utilityProps[11](value);

    shopCatalogueContainer.current.scrollIntoView();
  };
  const handleSearchFieldValue = (e) => {
    setSearchFiledValue(e.target.value);
  };
  useEffect(() => {
    setCurrentItems([]);
    setTimeout(() => {
      setCurrentItems(
        utilityProps[0].slice(
          utilityProps[12] * itemsPerPage - itemsPerPage,
          utilityProps[12] * itemsPerPage
        )
      );
    }, 500);
  }, [utilityProps[12], utilityProps[0]]);

  useEffect(() => {
    // utilityProps[11](1);
    // setCurrentPage(1);
  }, [utilityProps[0]]);

  return (
    <div ref={shopCatalogueContainer} className="shop-catalogue-container">
      <div className="shop-catalogue-sorting">
        <div className="shop-catalogue-chosenCategory-container">
          <p className="shop-catalogue-chosenCategory-p0">
            Избрана категория :
          </p>
          <p className="shop-catalogue-chosenCategory-p1">{utilityProps[9]}</p>
          <p className="shop-catalogue-chosenCategory-p2">
            {" "}
            {utilityProps[0].length} резултата
          </p>
        </div>

        <Box sx={{ width: "90%", ml: "auto", mr: "auto" }}>
          <FormControl fullWidth>
            <InputLabel
              sx={{ backgroundColor: "white" }}
              id="demo-simple-select-label"
            >
              Потърси модел в избраната кетегория
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={utilityProps[1]}
              label="sort"
              onChange={utilityProps[2]}
            >
              <MenuItem value={"Nike Mercurial"}>Nike Mercurial</MenuItem>
              <MenuItem value={"Nike Phantom"}>Nike Phantom</MenuItem>
              <MenuItem value={"Nike Tiempo"}>Nike Tiempo</MenuItem>
              <MenuItem value={"Adidas Copa"}>Adidas Copa</MenuItem>
              <MenuItem value={"Adidas Speedflow"}>Adidas Speedflow</MenuItem>
              <MenuItem value={"Adidas Speedportal"}>
                Adidas Speedportal
              </MenuItem>
              <MenuItem value={"Adidas Predator"}>Adidas Predator</MenuItem>
              <MenuItem value={"Adidas Nemeziz"}>Adidas Nemeziz</MenuItem>
              <MenuItem value={"Puma Future"}>Puma Future</MenuItem>
              <MenuItem value={"Puma Ultra"}>Puma Ultra</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <div className="shop-catalogue-sorting-search-bar-container">
          <TextField
            sx={{ width: "100%" }}
            onChange={handleSearchFieldValue}
            id="outlined-basic"
            label="Търсачка"
            variant="outlined"
          />
          <SearchIcon
            sx={{
              backgroundColor: "rgb(2, 85, 31,0.7)",
              fontSize: "40px",
              borderRadius: "25%",
              cursor: "pointer",
            }}
            onClick={() => {
              utilityProps[10](searchFiledValue);
            }}
          />
        </div>
      </div>
      <div className="shop-catalogue-items">
        {currentItems.map((item) => {
          return (
            <ShopPageCard
              key={item.id}
              sizes={item.sizes}
              isOnSale={item.isOnSale}
              imgSrc1={item.imgId1}
              imgSrc2={item.imgId2}
              imgSrc3={item.imgId3}
              imgSrc4={item.imgId4}
              name={item.name}
              description={item.description}
              price={item.price}
              oldPrice={item.oldPrice}
              itemId={item.id}
              handleAddToCart={utilityProps[3]}
              handleIsItemFocus={utilityProps[6]}
            />
          );
        })}
      </div>

      <Pagination
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: "2rem",
          mt: "4rem",
        }}
        page={utilityProps[12]}
        onChange={handlePageChange}
        count={Math.ceil(Number(utilityProps[0].length) / itemsPerPage)}
        shape="rounded"
      />
    </div>
  );
};
